<template>
  <span
    class="inline-flex items-center whitespace-nowrap rounded-sm border px-2 py-0.5 text-xs font-medium uppercase tracking-wide"
    :class="groupClasses"
    data-cy="conflict-matched-field"
  >
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {
  CONFLICT_GROUP_CLASSES,
  conflictFieldGroup,
  conflictFieldLabel,
} from '../constants/conflictFieldConstants';
import type { ConflictFieldId } from '../models/conflictTypes';

const props = defineProps<{ field: ConflictFieldId }>();

const label = computed(() => conflictFieldLabel(props.field));
const group = computed(() => conflictFieldGroup(props.field));
const groupClasses = computed(() => CONFLICT_GROUP_CLASSES[group.value]);
</script>
